/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {CreateHarvestReport} from '../bioplanModels';
// @ts-ignore
import type {HarvestReport} from '../bioplanModels';
// @ts-ignore
import type {ReportHarvest} from '../bioplanModels';
// @ts-ignore
import type {UpdateHarvestReport} from '../bioplanModels';
/**
 * ReportingHarvestApi - axios parameter creator
 * @export
 */
export const ReportingHarvestApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get all harvest reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/harvestReports/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} harvestReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdDelete: async (
      harvestReportId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestReportId' is not null or undefined
      assertParamExists('harvestReportsHarvestReportIdDelete', 'harvestReportId', harvestReportId);
      const localVarPath = `/harvestReports/{harvestReportId}`.replace(
        `{${'harvestReportId'}}`,
        encodeURIComponent(String(harvestReportId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Download a harvest report in Excel format
     * @param {string} harvestReportId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdDownloadGet: async (
      harvestReportId: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestReportId' is not null or undefined
      assertParamExists('harvestReportsHarvestReportIdDownloadGet', 'harvestReportId', harvestReportId);
      const localVarPath = `/harvestReports/{harvestReportId}/download`.replace(
        `{${'harvestReportId'}}`,
        encodeURIComponent(String(harvestReportId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get a single harvest report, including the harvests
     * @param {string} harvestReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdGet: async (
      harvestReportId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestReportId' is not null or undefined
      assertParamExists('harvestReportsHarvestReportIdGet', 'harvestReportId', harvestReportId);
      const localVarPath = `/harvestReports/{harvestReportId}`.replace(
        `{${'harvestReportId'}}`,
        encodeURIComponent(String(harvestReportId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all harvests in a report
     * @param {string} harvestReportId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdHarvestsGet: async (
      harvestReportId: string,
      startDate?: string,
      endDate?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestReportId' is not null or undefined
      assertParamExists('harvestReportsHarvestReportIdHarvestsGet', 'harvestReportId', harvestReportId);
      const localVarPath = `/harvestReports/{harvestReportId}/harvests`.replace(
        `{${'harvestReportId'}}`,
        encodeURIComponent(String(harvestReportId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} harvestReportId
     * @param {UpdateHarvestReport} updateHarvestReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdPatch: async (
      harvestReportId: string,
      updateHarvestReport: UpdateHarvestReport,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'harvestReportId' is not null or undefined
      assertParamExists('harvestReportsHarvestReportIdPatch', 'harvestReportId', harvestReportId);
      // verify required parameter 'updateHarvestReport' is not null or undefined
      assertParamExists('harvestReportsHarvestReportIdPatch', 'updateHarvestReport', updateHarvestReport);
      const localVarPath = `/harvestReports/{harvestReportId}`.replace(
        `{${'harvestReportId'}}`,
        encodeURIComponent(String(harvestReportId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(updateHarvestReport, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Generate a harvest report from a plan
     * @param {CreateHarvestReport} createHarvestReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsPost: async (
      createHarvestReport: CreateHarvestReport,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'createHarvestReport' is not null or undefined
      assertParamExists('harvestReportsPost', 'createHarvestReport', createHarvestReport);
      const localVarPath = `/harvestReports/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(createHarvestReport, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * ReportingHarvestApi - functional programming interface
 * @export
 */
export const ReportingHarvestApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = ReportingHarvestApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Get all harvest reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsGet(
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HarvestReport>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsGet(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} harvestReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsHarvestReportIdDelete(
      harvestReportId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsHarvestReportIdDelete(
        harvestReportId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsHarvestReportIdDelete']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Download a harvest report in Excel format
     * @param {string} harvestReportId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsHarvestReportIdDownloadGet(
      harvestReportId: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsHarvestReportIdDownloadGet(
        harvestReportId,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsHarvestReportIdDownloadGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get a single harvest report, including the harvests
     * @param {string} harvestReportId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsHarvestReportIdGet(
      harvestReportId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestReport>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsHarvestReportIdGet(
        harvestReportId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsHarvestReportIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all harvests in a report
     * @param {string} harvestReportId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsHarvestReportIdHarvestsGet(
      harvestReportId: string,
      startDate?: string,
      endDate?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportHarvest>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsHarvestReportIdHarvestsGet(
        harvestReportId,
        startDate,
        endDate,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsHarvestReportIdHarvestsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} harvestReportId
     * @param {UpdateHarvestReport} updateHarvestReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsHarvestReportIdPatch(
      harvestReportId: string,
      updateHarvestReport: UpdateHarvestReport,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestReport>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsHarvestReportIdPatch(
        harvestReportId,
        updateHarvestReport,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsHarvestReportIdPatch']?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Generate a harvest report from a plan
     * @param {CreateHarvestReport} createHarvestReport
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async harvestReportsPost(
      createHarvestReport: CreateHarvestReport,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HarvestReport>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.harvestReportsPost(createHarvestReport, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['ReportingHarvestApi.harvestReportsPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * ReportingHarvestApi - factory interface
 * @export
 */
export const ReportingHarvestApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = ReportingHarvestApiFp(configuration);
  return {
    /**
     *
     * @summary Get all harvest reports
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<HarvestReport>> {
      return localVarFp.harvestReportsGet(options).then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportingHarvestApiHarvestReportsHarvestReportIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdDelete(
      requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .harvestReportsHarvestReportIdDelete(requestParameters.harvestReportId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Download a harvest report in Excel format
     * @param {ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdDownloadGet(
      requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<File> {
      return localVarFp
        .harvestReportsHarvestReportIdDownloadGet(
          requestParameters.harvestReportId,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get a single harvest report, including the harvests
     * @param {ReportingHarvestApiHarvestReportsHarvestReportIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdGet(
      requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestReport> {
      return localVarFp
        .harvestReportsHarvestReportIdGet(requestParameters.harvestReportId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all harvests in a report
     * @param {ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdHarvestsGet(
      requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<ReportHarvest>> {
      return localVarFp
        .harvestReportsHarvestReportIdHarvestsGet(
          requestParameters.harvestReportId,
          requestParameters.startDate,
          requestParameters.endDate,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {ReportingHarvestApiHarvestReportsHarvestReportIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsHarvestReportIdPatch(
      requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdPatchRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestReport> {
      return localVarFp
        .harvestReportsHarvestReportIdPatch(
          requestParameters.harvestReportId,
          requestParameters.updateHarvestReport,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Generate a harvest report from a plan
     * @param {ReportingHarvestApiHarvestReportsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    harvestReportsPost(
      requestParameters: ReportingHarvestApiHarvestReportsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<HarvestReport> {
      return localVarFp
        .harvestReportsPost(requestParameters.createHarvestReport, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for harvestReportsHarvestReportIdDelete operation in ReportingHarvestApi.
 * @export
 * @interface ReportingHarvestApiHarvestReportsHarvestReportIdDeleteRequest
 */
export interface ReportingHarvestApiHarvestReportsHarvestReportIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdDelete
   */
  readonly harvestReportId: string;
}

/**
 * Request parameters for harvestReportsHarvestReportIdDownloadGet operation in ReportingHarvestApi.
 * @export
 * @interface ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGetRequest
 */
export interface ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGetRequest {
  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGet
   */
  readonly harvestReportId: string;

  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for harvestReportsHarvestReportIdGet operation in ReportingHarvestApi.
 * @export
 * @interface ReportingHarvestApiHarvestReportsHarvestReportIdGetRequest
 */
export interface ReportingHarvestApiHarvestReportsHarvestReportIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdGet
   */
  readonly harvestReportId: string;
}

/**
 * Request parameters for harvestReportsHarvestReportIdHarvestsGet operation in ReportingHarvestApi.
 * @export
 * @interface ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGetRequest
 */
export interface ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGetRequest {
  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGet
   */
  readonly harvestReportId: string;

  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGet
   */
  readonly endDate?: string;
}

/**
 * Request parameters for harvestReportsHarvestReportIdPatch operation in ReportingHarvestApi.
 * @export
 * @interface ReportingHarvestApiHarvestReportsHarvestReportIdPatchRequest
 */
export interface ReportingHarvestApiHarvestReportsHarvestReportIdPatchRequest {
  /**
   *
   * @type {string}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdPatch
   */
  readonly harvestReportId: string;

  /**
   *
   * @type {UpdateHarvestReport}
   * @memberof ReportingHarvestApiHarvestReportsHarvestReportIdPatch
   */
  readonly updateHarvestReport: UpdateHarvestReport;
}

/**
 * Request parameters for harvestReportsPost operation in ReportingHarvestApi.
 * @export
 * @interface ReportingHarvestApiHarvestReportsPostRequest
 */
export interface ReportingHarvestApiHarvestReportsPostRequest {
  /**
   *
   * @type {CreateHarvestReport}
   * @memberof ReportingHarvestApiHarvestReportsPost
   */
  readonly createHarvestReport: CreateHarvestReport;
}

/**
 * ReportingHarvestApi - object-oriented interface
 * @export
 * @class ReportingHarvestApi
 * @extends {BaseAPI}
 */
export class ReportingHarvestApi extends BaseAPI {
  /**
   *
   * @summary Get all harvest reports
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsGet(options?: RawAxiosRequestConfig) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsGet(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportingHarvestApiHarvestReportsHarvestReportIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsHarvestReportIdDelete(
    requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsHarvestReportIdDelete(requestParameters.harvestReportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Download a harvest report in Excel format
   * @param {ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsHarvestReportIdDownloadGet(
    requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdDownloadGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsHarvestReportIdDownloadGet(
        requestParameters.harvestReportId,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get a single harvest report, including the harvests
   * @param {ReportingHarvestApiHarvestReportsHarvestReportIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsHarvestReportIdGet(
    requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsHarvestReportIdGet(requestParameters.harvestReportId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all harvests in a report
   * @param {ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsHarvestReportIdHarvestsGet(
    requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdHarvestsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsHarvestReportIdHarvestsGet(
        requestParameters.harvestReportId,
        requestParameters.startDate,
        requestParameters.endDate,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {ReportingHarvestApiHarvestReportsHarvestReportIdPatchRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsHarvestReportIdPatch(
    requestParameters: ReportingHarvestApiHarvestReportsHarvestReportIdPatchRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsHarvestReportIdPatch(
        requestParameters.harvestReportId,
        requestParameters.updateHarvestReport,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Generate a harvest report from a plan
   * @param {ReportingHarvestApiHarvestReportsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ReportingHarvestApi
   */
  public harvestReportsPost(
    requestParameters: ReportingHarvestApiHarvestReportsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return ReportingHarvestApiFp(this.configuration)
      .harvestReportsPost(requestParameters.createHarvestReport, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
